// Brand glyphs as inline SVGs — this lucide-react version no longer ships brand
// icons. Each accepts a `size` prop (px) and renders in currentColor.

function Svg({ size = 16, children, filled = true, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export function InstagramIcon({ size = 16, ...props }) {
  return (
    <Svg size={size} filled={false} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="2.5" y="2.5" width="19" height="19" rx="5.2" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.3" cy="6.7" r="1.1" fill="currentColor" stroke="none" />
    </Svg>
  );
}

export function FacebookIcon({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12Z" />
    </Svg>
  );
}

export function TikTokIcon({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M16.5 3c.32 2.1 1.55 3.55 3.5 3.86v2.63c-1.24.06-2.42-.3-3.5-1v5.68c0 3.3-2.4 5.83-5.6 5.83A5.53 5.53 0 0 1 5.3 14.5c0-3.02 2.34-5.42 5.35-5.42.3 0 .6.02.85.07v2.74a2.9 2.9 0 0 0-.85-.14 2.62 2.62 0 0 0-2.6 2.75c0 1.55 1.15 2.73 2.65 2.73 1.5 0 2.7-1.2 2.7-2.95V3h3.1Z" />
    </Svg>
  );
}

export function YouTubeIcon({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M23 12s0-3.3-.42-4.86a2.55 2.55 0 0 0-1.8-1.8C19.2 5 12 5 12 5s-7.2 0-8.78.34a2.55 2.55 0 0 0-1.8 1.8C1 8.7 1 12 1 12s0 3.3.42 4.86c.23.86.94 1.5 1.8 1.72C4.8 19 12 19 12 19s7.2 0 8.78-.42a2.55 2.55 0 0 0 1.8-1.72C23 15.3 23 12 23 12ZM9.75 15.02V8.98L15.5 12l-5.75 3.02Z" />
    </Svg>
  );
}

export function XIcon({ size = 16, ...props }) {
  return (
    <Svg size={size} {...props}>
      <path d="M17.53 3h3.2l-6.99 7.99L22 21h-6.44l-5.04-6.2L4.75 21H1.53l7.48-8.55L2 3h6.6l4.56 5.93L17.53 3Zm-1.12 16.05h1.77L7.66 4.86H5.76l10.65 14.19Z" />
    </Svg>
  );
}
